import { IIconBase } from '..'

const codeIcon = ({
  color = '#000000',
  height = 24,
  width = 24,
}: IIconBase) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='lucide lucide-code-icon lucide-code'
    >
      <path d='m16 18 6-6-6-6' />
      <path d='m8 6-6 6 6 6' />
    </svg>
  )
}

export default codeIcon
